import BaseModel from "./../base/baseModel";

export default class BandeiraModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    ativo = true;
}
